var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 16.5,
    viewBox: "0 0 21.5 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1.25 -3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3339",
    "data-name": "Path 3339",
    d: "M13.75,15v1A3.768,3.768,0,0,1,10,19.75H5A3.751,3.751,0,0,1,1.25,16V15a4.746,4.746,0,0,1,2.29-4.06,5.237,5.237,0,0,0,7.92,0,4.755,4.755,0,0,1,1.97,2.34A4.65,4.65,0,0,1,13.75,15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3340",
    "data-name": "Path 3340",
    d: "M22.75,16v1A2.748,2.748,0,0,1,20,19.75H15a2.7,2.7,0,0,1-1.56-.49l.02-.02A4.706,4.706,0,0,0,14.75,16V15a4.985,4.985,0,0,0-.14-1.23,4.691,4.691,0,0,0,2.89.98,4.745,4.745,0,0,0,3.71-1.78A3.758,3.758,0,0,1,22.75,16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 4.25,
    cy: 4.25,
    r: 4.25,
    transform: "translate(3.25 3.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 3.75,
    cy: 3.75,
    r: 3.75,
    transform: "translate(13.75 6.25)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.6345a1841cae47926875129c454a80ea.svg";
export { ForwardRef as ReactComponent };